import { render, staticRenderFns } from "./PersonalMain.vue?vue&type=template&id=6b820cc9"
import script from "./PersonalMain.vue?vue&type=script&lang=js"
export * from "./PersonalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports